export default __webpack_public_path__ + "static/media/txt_h3.f6897f85.svg";